import { render, staticRenderFns } from "./externalLink.vue?vue&type=template&id=4f3ae1cc&scoped=true&"
import script from "./externalLink.vue?vue&type=script&lang=js&"
export * from "./externalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ae1cc",
  null
  
)

export default component.exports